import { privateApi } from 'services';
import { LinkedinLeadGenForm } from './types';

const fetchLinkedinLeadGenForms = async (adAccountId: string): Promise<LinkedinLeadGenForm[]> =>
    privateApi.get<LinkedinLeadGenForm[]>(`linkedin/ad-accounts/${adAccountId}/lead-forms`);

export const LinkedinLeadGenFormGateway = {
    fetchLinkedinLeadGenForms,
};
